module.exports = __webpack_public_path__ + "img/124.5.3e65ca4a.png";